import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import { shallowRef } from "vue";
import { app } from "@/di";
import { NegotiationComponentManager } from "@/modules/diplomacy/services/NegotiationComponentManager";
import { Negotiation } from "@/modules/diplomacy/entity";
import { onBeforeRouteLeave } from "vue-router";
export default /*#__PURE__*/_defineComponent({
  __name: 'Show',
  async setup(__props) {
    let __temp, __restore;
    const route = useRoute();
    const negotiation = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      negotiation.value = await tap(await Negotiation.createQueryBuilder('negotiation').innerJoinAndSelect('negotiation.team', 'team').where('negotiation.id = :id', {
        id: route.params.id
      }).getOneOrFail(), n => n.init());
    })), __temp = await __temp, __restore(), __temp);
    onBeforeRouteLeave(watch(() => route.params, refresh));
    const component = shallowRef(app.get(NegotiationComponentManager).getComponent(negotiation.value));
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: ""
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('negotiation')), 1)]),
        default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component)), {
          negotiation: negotiation.value,
          "show-attributes": "",
          onClosed: _unref(refresh),
          onUpdated: _unref(refresh)
        }, null, 40, ["negotiation", "onClosed", "onUpdated"]))]),
        _: 1
      });
    };
  }
});